module.exports = __webpack_public_path__ + "static/media/logo-white.6148359c.svg";